import { render, staticRenderFns } from "./company-document.vue?vue&type=template&id=0071db48&"
import script from "./company-document.vue?vue&type=script&lang=js&"
export * from "./company-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports